// @ts-check
import { z } from 'zod';

import Permission from '@/store/modules/models/global/Permission';
import { SharingSummary } from '@/store/modules/users/models';
import Timestamp from '@/store/modules/models/global/Timestamp';

import Parties from '@/store/modules/envelopes/models/Parties';

export const Envelope = z.object({
  auto_remind_hours: z.number().nullable(),
  company_id: z.number(),
  created_at: Timestamp,
  deleted_at: Timestamp,
  everyone_permission: Permission.nullable(),
  fingerprint: z.string(),
  id: z.number(),
  is_parallel_signing_enabled: z.boolean().nullable(),
  meta_data: z.string(),
  next_expire: Timestamp,
  next_remind: Timestamp,
  parties: Parties,
  processed_at: Timestamp,
  redirect_url: z.string().nullable(),
  rejection_party_id: z.number().nullable(),
  rejection_reason: z.string().nullable(),
  reminded: Timestamp,
  sent_at: Timestamp,
  sharing: SharingSummary,
  status: z.enum([
    'processing',
    'failed',
    'initial',
    'draft',
    'sent',
    'signed',
    'rejected',
    'verify',
    'cancelled',
    'expired',
  ]),
  thumbnail: z.string().nullable(),
  title: z.string(),
  user_id: z.number().nullable(),
});

export const ListEnvelope = Envelope.pick({
  fingerprint: true,
  title: true,
  created_at: true,
  status: true,
  thumbnail: true,
  is_parallel_signing_enabled: true,
}).extend({
  parties: Envelope.shape.parties.element.pick({
    title: true,
    selected: true,
    email: true,
    id: true,
  }).extend({
    status: Envelope.shape.parties.element.shape.status.pick({
      action_performed_date: true,
      sent: true,
      computed_status: true,
      computed_status_date: true,
    }),
  }).array(),
});

/** @typedef {z.infer<typeof Envelope>} TEnvelope */
/** @typedef {z.infer<typeof ListEnvelope>} TListEnvelope */
